import { ArrowDownRight, MapPin } from "lucide-react";
import { MEDIA, BOOKING } from "../i18n";
import { openCalendly } from "../utils/calendly";
import Reveal from "./Reveal";

export default function Hero({ t }) {
  const handleDiscovery = () => openCalendly(BOOKING.calendlyDiscovery);
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex flex-col justify-end overflow-hidden pt-32 pb-16 bg-grain"
    >
      {/* Background image */}
      <div className="absolute inset-0 -z-10">
        <img
          src={MEDIA.hero}
          alt="Meditative light over Barcelona"
          className="w-full h-full object-cover slow-zoom"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(253,251,247,0.75) 0%, rgba(253,251,247,0.35) 35%, rgba(253,251,247,0.85) 100%)",
          }}
        />
      </div>

      <div className="max-w-[1400px] w-full mx-auto px-6 md:px-10 hero-grid gap-10 lg:gap-20 items-end">
        <div>
          <Reveal>
            <span className="overline block mb-10" data-testid="hero-overline">
              {t.hero.overline}
            </span>
          </Reveal>

          <Reveal delay={120}>
            <h1
              className="font-serif text-[2.75rem] md:text-[4.5rem] lg:text-[6rem] leading-[0.98] tracking-[-0.02em] text-[#3E362E] whitespace-pre-line"
              data-testid="hero-title"
            >
              {t.hero.title}
            </h1>
          </Reveal>

          <Reveal delay={260}>
            <div className="flex items-center mt-8 gap-3 text-[#7D746A] text-sm">
              <MapPin size={14} />
              <span className="tracking-wide">{t.hero.location}</span>
              <span className="divider-dot" />
              <span className="font-chinese text-[#1A9BC1]">源 · Yuan</span>
            </div>
          </Reveal>
        </div>

        <div className="flex flex-col gap-8 lg:pl-10 lg:border-l lg:border-[#E8E1D9]">
          <Reveal delay={360}>
            <p
              className="text-base md:text-lg text-[#5E554C] font-light leading-relaxed max-w-md"
              data-testid="hero-description"
            >
              {t.hero.description}
            </p>
          </Reveal>

          <Reveal delay={480}>
            <div className="flex flex-wrap gap-4">
              <button
                type="button"
                onClick={handleDiscovery}
                className="btn-accent"
                data-testid="hero-cta-primary"
              >
                {t.hero.primaryCta}
                <ArrowDownRight size={16} />
              </button>
              <a href="#therapies" className="btn-primary" data-testid="hero-cta-secondary">
                {t.hero.secondaryCta}
              </a>
            </div>
          </Reveal>
        </div>
      </div>

      {/* Marquee strip */}
      <div className="mt-20 overflow-hidden border-y border-[#E8E1D9] py-5">
        <div className="marquee-track flex whitespace-nowrap text-[#8D7B68] text-sm tracking-[0.25em] uppercase">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex shrink-0">
              {[
                "Quantum Healing",
                "源 Yuan",
                "Dolores Cannon Method",
                "Barcelona",
                "Hipnosis Cuántica",
                "Level 2 Practitioner",
                "Regresión Grupal",
                "Limpieza Energética",
              ].map((w, j) => (
                <span key={`${i}-${j}`} className="flex items-center">
                  <span className="px-8">{w}</span>
                  <span className="divider-dot" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
